<template>
    <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh py-5">
            <Col :xs="24" :md="22" :lg="20">
                <Card class="shadow">
                    <Row align="middle">
                        <Col :xs="24" :md="{ span: 16, offset: 4 }">
                            <h1 class="text-center text-24">{{ $t("views.register.title") }}</h1>
                        </Col>
                        <Col :xs="24" :md="{ span: 16, offset: 4 }">
                            <div><a :href="officerManual"><CIcon file="pdf.svg"></CIcon>{{ $t("views.manual.officerManual") }}</a></div>
                            <div><a :href="officerRegisterForm"><CIcon file="pdf.svg"></CIcon>{{ $t("views.manual.officerRegisterForm") }}</a></div>
                            <Divider></Divider>
                        </Col>
                        <Col :xs="24">
                            <Form :ref="e => (refs.form = e)" layout="horizontal">
                                <TemplateBuilder
                                    :rowProp="data.rowProp"
                                    :useForm="data.useForm"
                                    :fields="data.fields"
                                    :skeleton="isLoading"
                                ></TemplateBuilder>
                            </Form>
                            <div class="d-flex">
                                <Button class="mx-auto btn-primary" @click="() => onClickOpenModalOtp({ props, data, refs })" :disabled="isLoading">
                                    <CIcon file="save.svg"></CIcon>
                                    <span>{{ $t("button.register") }}</span>
                                </Button>
                            </div>
                            <div class="text-center">
                                <router-link :to="{ name: 'login' }">{{ $t("button.login") }}</router-link>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>
import { Button, Card, Col, Form, Layout, Row, Divider } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../app.logic";
import { initForm, isLoading, onClickOpenModalOtp } from "./register-officer.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        Button,
        Layout,
        Row,
        Col,
        Divider,
        TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder")),
        CIcon: defineAsyncComponent(() => import("../../../components/icon/CIcon"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false }
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 } });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        return {
            props,
            data,
            refs,
            isLoading,
            onClickOpenModalOtp,
            officerManual: `${process.env.VUE_APP_API_URL}/files/manual/ขั้นตอนการลงทะเบียนระบบ HAZDOF สำหรับเจ้าหน้าที่.pdf`,
            officerRegisterForm: `${process.env.VUE_APP_API_URL}/files/manual/แบบลงทะเบียนเจ้าหน้าที่ ระบบ HAZDOF.pdf`,
        };
    }
});
</script>

<style scoped>
.bg-account {
    background-image: url("../../../assets/bg/bg-account.jpg");
    background-size: 100% 100%;
}
</style>
